import { Default } from "../InitialState";

export const handleChangeBechmarkFiltering = (state, payload) => {
    if (payload.isFromSaveFilter) {
        return {
            ...state,
            benchmarkFilters: {
                ...state.benchmarkFilters,
                ...payload.changedItem

            }

        }
    }
    else {
        return {
            ...state,
            benchmarkFiltersAnalysis: {
                ...state.benchmarkFiltersAnalysis,
                ...payload.changedItem
            }
        }
    }

}

export const handleChangeSampleCommentsFilter = (state, payload) => {
    return {
        ...state,
        sampleCommentsFilters: {
            ...state.sampleCommentsFilters,
            ...payload
        }
    }
}

export const handleReassignExistingData = (state, payload) => {
    return {
        ...state,
        benchmarkFilters: {
            ...state.benchmarkFilters,
            ...payload


        }

    }
}

export const handleChangeComparissonToggle = (state, payload) => {
    return {
        ...state,
        isTrendComparison: payload.value
    }
}

// Whether what's in the store was fetched for the filters currently applied.
// The trend APIs are expensive and the toggle mounts/unmounts the whole view,
// so flipping it back on reuses these results; only Apply marks them stale.
export const handleSetTrendDataFetched = (state, payload) => {
    return {
        ...state,
        isTrendDataFetched: payload.value
    }
}

// The same for the plain visualizations. Applying fetches one side or the
// other — whichever the comparison toggle is showing — so each side tracks
// separately whether it still matches the filters that are applied.
export const handleSetBenchmarkDataFetched = (state, payload) => {
    return {
        ...state,
        isBenchmarkDataFetched: payload.value
    }
}

// Switching how everyone is matched drops the hand-picked baselines — the
// radio is a statement about the whole list, so it shouldn't leave rows
// silently opted out of it.
// A new match mode changes the baseline on every compared row, so every
// loaded row would re-render. Cutting the loaded list back to `keepRows` caps
// that; the rows past it unmount, and infinite scroll fetches them again
// (from `keepRows` on) only if the user scrolls that far. The kept leaders are
// the same objects, so paging resumes exactly where the cut left it.
const trimComparedList = (state, keepRows) => {
    const api = state.fetchProjectComparisonApi;
    const data = api.data || [];
    if (!keepRows || data.length <= keepRows) return state;
    return {
        ...state,
        fetchProjectComparisonApi: {
            ...api,
            data: data.slice(0, keepRows),
            // Whatever was cut is now "more"; an in-flight page is abandoned
            // (its response no longer lines up — see fetchProjectComparisonSuccess).
            hasMore: true,
            isLoadingMore: false
        }
    };
};

// payload: { value, keepRows }
export const handleChangeTrendMatchMode = (state, payload) => {
    const trimmed = payload.value !== state.trendPairing.matchMode
        ? trimComparedList(state, payload.keepRows)
        : state;
    return {
        ...trimmed,
        trendPairing: {
            ...state.trendPairing,
            matchMode: payload.value,
            baselineOverrides: {}
        }
    }
}

// Re-pointing one participant at a different earlier 360 only touches that
// participant; everyone else keeps the round they were matched to.
// payload: { projectId, value } — the leader's current 360 and the earlier one
// picked as its baseline, so an override reads as { current: baseline }.
export const handleChangeTrendBaseline = (state, payload) => {
    return {
        ...state,
        trendPairing: {
            ...state.trendPairing,
            baselineOverrides: {
                ...state.trendPairing.baselineOverrides,
                [payload.projectId]: payload.value
            }
        }
    }
}

// The whole pairing back to how it starts — match mode and hand-picked
// baselines, pending and applied alike. Applying new filters rebuilds the lists,
// and an override names one leader's pair of 360s, so there's no reason to think
// any of it still applies. Taken from the initial state itself, so it can't drift
// from it.
export const resetTrendPairing = (state) => {
    return {
        ...state,
        trendPairing: Default().trendPairing
    }
}

// Back to whatever the results are currently built from. If that switches the
// match mode back, the list is trimmed the same way as a radio change.
// payload: { keepRows }
export const discardTrendPairing = (state, payload) => {
    const { applied } = state.trendPairing;
    const trimmed = applied.matchMode !== state.trendPairing.matchMode
        ? trimComparedList(state, payload && payload.keepRows)
        : state;
    return {
        ...trimmed,
        trendPairing: {
            ...state.trendPairing,
            matchMode: applied.matchMode,
            baselineOverrides: applied.baselineOverrides
        }
    }
}

// Promotes the pairing on screen to the one the results are built from.
export const applyTrendPairing = (state) => {
    const { matchMode, baselineOverrides } = state.trendPairing;
    return {
        ...state,
        trendPairing: {
            ...state.trendPairing,
            applied: { matchMode, baselineOverrides }
        }
    }
}
